import styles from "./BundlesHomePage.module.css";
import { Box, Button, SkeletonDisplayText, Card, Text, Badge } from "@shopify/polaris";
import useIsMobile from "../../hooks/useIsMobile";
import useAnalyticsMixpanelHook from "../Analytics/hooks/useAnalyticsMixpanelHook";

const RevenueCard = ({
    statCards,
    loading,
}: {
    loading: boolean;
    statCards: {
        revenue: string;
        conversions: string;
        aov: string;
    };
}) => {
    const { isMobile } = useIsMobile();
    const { trackViewDetailedAnalytics } = useAnalyticsMixpanelHook();

    return (
        <div className={styles.revenueCardWrapper}>
            <div
                className={styles.revenueCardHeader}
                style={{
                    gap: isMobile ? "5px" : "",
                }}
            >
                <div className={styles.revenueCardLabel}>Analytics</div>
                <div
                    style={{
                        display: "flex",
                        gap: "2px",
                        alignItems: "center",
                    }}
                >
                    <Button
                        onClick={() => {
                            trackViewDetailedAnalytics({
                                cta: "View Detailed Analytics",
                                ctaType: "Click",
                                source: "Bundles Tab",
                            });

                            window.location.href = "/analytics";
                        }}
                    >
                        {
                            (
                                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    View Detailed Analytics
                                    <Badge size="small" tone="info">
                                        New
                                    </Badge>
                                </span>
                            ) as unknown as string
                        }
                    </Button>
                </div>
            </div>
            <div className={styles.revenueBody}>
                <div className={styles.bodyStatsLeft}>
                    {loading ? (
                        <div
                            className={styles.statsCardsParent}
                            style={{
                                gap: isMobile ? "5px" : "",
                            }}
                        >
                            <Card roundedAbove="sm" padding={"300"}>
                                <Text as="h4" variant="headingXs">
                                    Offer Revenue
                                </Text>
                                <Box paddingBlockStart="200">
                                    <Text as="h2" variant="headingLg">
                                        <SkeletonDisplayText maxWidth={"30%"} />
                                    </Text>
                                </Box>
                            </Card>

                            <Card roundedAbove="sm" padding={"300"}>
                                <Text as="h4" variant="headingXs">
                                    Offer Conversions
                                </Text>
                                <Box paddingBlockStart="200">
                                    <Text as="h2" variant="headingLg">
                                        <SkeletonDisplayText maxWidth={"30%"} />
                                    </Text>
                                </Box>
                            </Card>

                            <Card roundedAbove="sm" padding={"300"}>
                                <Text as="h4" variant="headingXs">
                                    Average Upsell Value
                                </Text>
                                <Box paddingBlockStart="200">
                                    <Text as="h2" variant="headingLg">
                                        <SkeletonDisplayText maxWidth={"30%"} />
                                    </Text>
                                </Box>
                            </Card>
                        </div>
                    ) : (
                        <div
                            className={styles.statsCardsParent}
                            style={{
                                gap: isMobile ? "5px" : "",
                            }}
                        >
                            {/* <div className={styles.statsVal}>${statCards.revenue}</div> */}

                            <span className={styles.singleCard}>
                                <Card roundedAbove="sm" padding={"300"}>
                                    <Text as="h4" variant="headingXs">
                                        Offer Revenue
                                    </Text>
                                    <Box paddingBlockStart="200">
                                        <Text as="h2" variant="headingXl">
                                            ${statCards?.revenue}
                                        </Text>
                                    </Box>
                                </Card>
                            </span>

                            <span className={styles.singleCard}>
                                <Card roundedAbove="sm" padding={"300"}>
                                    <Text as="h4" variant="headingXs">
                                        Offer Conversions
                                    </Text>
                                    <Box paddingBlockStart="200">
                                        <Text as="h2" variant="headingXl">
                                            {statCards?.conversions}
                                        </Text>
                                    </Box>
                                </Card>
                            </span>

                            <span className={styles.singleCard}>
                                <Card roundedAbove="sm" padding={"300"}>
                                    <Text as="h4" variant="headingXs">
                                        Average Upsell Value
                                    </Text>
                                    <Box paddingBlockStart="200">
                                        <Text as="h2" variant="headingXl">
                                            ${statCards?.aov}
                                        </Text>
                                    </Box>
                                </Card>
                            </span>
                            {/* <div className={styles.statsChangeBy}>
                            20%
                            <span
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    transform: "rotate(90deg)",
                                }}
                            >
                                <LeftArrow />
                            </span>
                        </div> */}
                        </div>
                    )}
                </div>
                <div className={styles.bodyCtaRight} style={{ display: "none" }}>
                    <Button variant={"primary"}>View Detailed Analysis</Button>
                </div>
            </div>
        </div>
    );
};

export default RevenueCard;
